import { useState, useEffect } from 'react';
import Echo from 'laravel-echo';
import { SecureStorage } from '../Utilities/StorageEncryption';

const useLaravelEcho = () => {
    const [echoInstance, setEchoInstance] = useState(null);
    window.Pusher = require('pusher-js');

    useEffect(() => {
        const tokenKey = JSON.parse(SecureStorage.getItem('tokenKey'));
        const echo = new Echo({
            broadcaster: process.env.REACT_APP_LARAVEL_ECHO_BROADCASTER,
            key: process.env.REACT_APP_LARAVEL_ECHO_KEY,
            wsHost: process.env.REACT_APP_LARAVEL_ECHO_WS_HOST,
            wsPort: process.env.REACT_APP_LARAVEL_ECHO_WS_PORT,
            wssPort: process.env.REACT_APP_LARAVEL_ECHO_WSS_PORT,
            forceTLS: false,
            encrypted: true,
            disableStats: false,
            enabledTransports: ['ws', 'wss'],
            cluster:'mt1',
            authEndpoint: process.env.REACT_APP_LARAVEL_ECHO_BROADCASTER_AUTH_ENDPOINT,
            auth: {
                headers: {
                    user: tokenKey.value
                }
            }
        });
        window.echo = echo;
        setEchoInstance(echo);
    }, []);

  return echoInstance;
};

export default useLaravelEcho;
